module.exports = __webpack_public_path__ + "fonts/FontsFree-Net-Mont-Bold.a44431b.ttf";